import { Component, EventEmitter, Inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { BackOfficeService } from '../../../../../services/backoffice.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, FormBuilder, Validators } from '@angular/forms';
import { BackOffice24UsersAddComponent } from '../back-office24-users-add/back-office24-users-add.component';
import { MyConfigService } from '../../../../../../app/services/my-config.service';

@Component({
  selector: 'app-back-office24-org-members',
  standalone: false,
  templateUrl: './back-office24-org-members.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './back-office24-org-members.component.css'
})
export class BackOffice24OrgMembersComponent {
  @Output() saveChangesEvent = new EventEmitter<any>();
  organizationForm: UntypedFormGroup;
  isLoading: boolean = false;
  membersList: any;
  organizationMemberTypes: any[];
  memberShipTypes: any[] = [];

  constructor(
    private backOfficeService: BackOfficeService,
    private formBuilder: FormBuilder,
    @Inject(MatDialogRef<BackOffice24UsersAddComponent>) private dialogRef: MatDialogRef<BackOffice24UsersAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      members: any,
      organizationId: any,
      targetOrganizationId: any,
      organizationMemberTypes?: any[],
      parkingMemberTypes?: any[],
      orgType?: any
    },
    private myConfigService: MyConfigService
  ) { }

  ngOnInit(): void {
    this.membersList = this.data?.members;
    this.organizationMemberTypes = this.data?.organizationMemberTypes;
    this.addOrganizationMembersForm();
    const config = this.myConfigService.getMyConfig();
    const currentOrg = config?.organizations?.find(org =>
      org.organizationId === this.data?.organizationId
    );

    if (this.data?.orgType === "ParkingCompany") {
      this.memberShipTypes = this.data?.parkingMemberTypes;
    } else {
      const userMembershipRight = currentOrg?.memberShipRight || 0;
      const matchingMemberTypes = this.getMatchingMemberTypes(Number(userMembershipRight));
      this.memberShipTypes = matchingMemberTypes?.length > 0 ? matchingMemberTypes : this.organizationMemberTypes;
    }
  }

  getMatchingMemberTypes(membershipRight: number): any[] {
    return this.organizationMemberTypes.filter(memberType =>
      memberType.id > 0 && (membershipRight & memberType.id) === memberType.id
    );
  }


  addOrganizationMembersForm() {
    this.organizationForm = this.formBuilder.group({
      member: ['', [Validators.required]],
      membershipType: [{ value: [], disabled: this.isLoading }]
    });
  }

  saveChanges(): void {
    if (this.organizationForm.invalid) {
      return;
    }
    this.isLoading = true;
    const selectedTypes = this.organizationForm.get('membershipType')?.value || [];
    const memberType = selectedTypes.reduce((sum: number, type: number) => sum | type, 0);
    const selectedMember = this.organizationForm.get('member')?.value;

    const payload = {
      firstname: selectedMember?.firstname,
      lastname: selectedMember?.lastname,
      email: selectedMember?.email,
      mobile: selectedMember?.mobile,
      smsVerification: Boolean(selectedMember?.smsVerification),
      defaultLanguage: selectedMember?.defaultLanguage,
      userId: selectedMember?.userId,
      organizationId: this.data.targetOrganizationId,
      memberType: memberType,
    };
    this.backOfficeService.createOrUpdateOrganizationMember(this.data.organizationId, payload).subscribe({
      next: (data) => {
        this.saveChangesEvent.emit({ data: data, userAdded: true });
      }
    })
    this.dialogRef.close();
  }
}
